// AudienceSection.jsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { MdArrowForward, MdGroups, MdFavorite, MdShield } from "react-icons/md";
import "./CheckInLanding.css";

const audiences = [
    {
        tag: "01",
        title: "Parents",
        body: "Respect boundaries and have reassurance about your college student's whereabouts.",
        Icon: MdGroups,
    },
    {
        tag: "02",
        title: "Seniors",
        body: "Put your adult children's minds at ease with frequent, low-effort check-ins.",
        Icon: MdFavorite,
    },
    {
        tag: "03",
        title: "Anyone Concerned",
        body: "Your peace of mind is our priority. Make it yours today with safeCircl.",
        Icon: MdShield,
    },
];

const AudienceSection = () => {
    return (
        <section className="audience-section">
            <Container>
                <div className="audience-heading text-center">
                    <h2 className="audience-title">
                        There's nothing more important <br className="d-none d-sm-block" />
                        <em>than your safety.</em>
                    </h2>

                    <p className="audience-subtitle">
                        Perfect for those "just in case" moments. Fully customizable — get
                        reminders as little or as much as you want.
                    </p>
                </div>

                <Row className="g-4 mt-4">
                    {audiences.map((item, index) => {
                        const Icon = item.Icon;

                        return (
                            <Col lg={4} md={6} key={index}>
                                <div className="audience-card">
                                    <span className="card-number">{item.tag}</span>

                                    <div className="card-overlay"></div>

                                    <div className="card-content">
                                        <div className="icon-box">
                                            <Icon size={26} />
                                        </div>

                                        <h3>{item.title}</h3>

                                        <p>{item.body}</p>

                                        <a href="#">
                                            Learn more
                                            <MdArrowForward size={18} />
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>

                <div className="cta-wrapper text-center mx-auto mt-5">
                    <h2 className="cta-title">
                        Maybe you're already checking in with your loved ones, but it's not
                        consistent.{" "}
                        <span className="cta-muted">
                            You don't want your slip-ups to cause them undue panic.
                        </span>
                    </h2>

                    <p className="cta-subtitle">
                        Let <span className="highlight-brand">safeCircl</span> do the work
                        in the background, so you can live life your way.
                    </p>

                    <div className="cta-btn-wrap">
                        <Button className="cta-btn">
                            Start Today
                            <MdArrowForward size={18} className="ms-2" />
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default AudienceSection;
